<ng-container *transloco="let t;">
    <div class="modal-header">
        <h4 class="modal-title" id="myModalLabel1">{{ t('Manage filters modal title (Manage filters modal) - Manage
            filters') }}</h4>
        <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="modal-body px-0" tabindex="0">
        <div class="manageFiltersWrappers">
            <div class="customColumnsWrapper px-2 pb-2">
                <div class="row pb-1 pt-50 border-bottom">
                    <div class="col-8"><h6 class="mb-0">{{ t('Name field (saved filters modal) - name') }}</h6></div>
                    <div class="col-2"><h6 class="mb-0">{{ t('Make public field (saved filters modal) - make public') }}</h6></div>
                    <div class="col-2 text-end"><h6 class="mb-0">{{ t('Table column name action (Content library - section) - Action') }}</h6></div>
                </div>
                <ng-scrollbar autoHeightDisabled="false" visibility="hover" class="filters-list">
                    <div class="">
                        @for (filter of filters; track filter; let index = $index) {
                            <div class="row py-1 border-top manage-filter-row">
                                <form #updateForm='ngForm' [formGroup]="editFilterForm" class="d-flex justify-content-start align-items-center" [ngClass]="{editable : filter.isEditMode}">
                                    @if (filter.isEditMode) {
                                        <div class="col-8 ps-0">
                                            <div class="sortColumnListText d-flex justify-content-start align-content-center">
                                                <div class="w-100">
                                                    <input type="text" id="filter_name_{{index}}"
                                                           class="form-control w-100"
                                                           [formControl]="editFilterForm.controls.name">
                                                    <div *ngIf="editFilterForm && editFilterForm.invalid"
                                                         class="invalid-feedback"
                                                         [ngClass]="{ 'd-block': editFilterForm.invalid }">
                                                        <div *ngIf="editFilterForm.controls.name.hasError('required')">
                                                            {{
                                                                t('Field required (form validation) - Field name is required', {
                                                                    fieldName: t('Name field (saved filters modal) - name')
                                                                })
                                                            }}
                                                        </div>
                                                        <div *ngIf="editFilterForm.controls.name.hasError('minlength')">
                                                            {{ t('Minimal length (validation message) Minimal length is', {min: editFilterForm.controls.name.getError('minlength')?.requiredLength}) }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-2 is-public-toggle align-baseline">
                                            <div class="custom-control custom-switch custom-control-inline pt-25">
                                                <input type="checkbox" id="is_public_{{index}}"
                                                       class="custom-control-input"
                                                       [formControl]="editFilterForm.controls.public"/>
                                                <label class="custom-control-label" for="is_public_{{index}}"></label>
                                            </div>
                                        </div>
                                    } @else {
                                        <div class="col-8 ps-0">
                                            <div class="custom-control custom-switch">
                                                {{ filter?.filter?.name }}
                                            </div>
                                        </div>
                                        <div class="col-2 is-public-toggle">
                                            <div class="custom-control custom-switch custom-control-inline pt-25">
                                                <input type="checkbox" id="is_public_{{index}}"
                                                       class="custom-control-input"
                                                       disabled 
                                                       [checked]="filter?.filter?.public"
                                                />
                                                <label class="custom-control-label"
                                                       for="is_public_{{index}}"></label>
                                            </div>
                                        </div>
                                    }
                                    <div class="col-2">
                                        <div class="d-flex justify-content-end align-items-center">
                                            @if (filter.isEditMode) {
                                                <span placement="auto" triggers="hover" *ngIf="globalService?.user_settings?.id === filter?.filter?.user_id"
                                                    [ngbTooltip]="t('Update button text (update button) - update')"
                                                    (click)="updateFilter(filter); updateForm.ngSubmit.next(editFilterForm.value)">
                                                    <i data-feather="save" class="font-medium-1 cursor-pointer text-success"></i>
                                                </span>
                                                <span placement="auto" triggers="hover" class="ps-1"
                                                    *ngIf="globalService?.user_settings?.id === filter?.filter?.user_id"
                                                    [ngbTooltip]="t('Reject button text (saved filters modal) - discard')" (click)="filter.isEditMode = false">
                                                    <i data-feather="x" class="font-medium-1 cursor-pointer text-danger"></i>
                                                </span>
                                            } @else {
                                                @if(globalService?.user_settings?.id === filter?.filter?.user_id){
                                                <div class="manage-filter-actiion">
                                                    <div ngbDropdown>
                                                        <button type="button" class="btn btn-sm hide-arrow py-0"
                                                            ngbDropdownToggle data-toggle="dropdown">
                                                            <i data-feather="more-vertical"></i>
                                                        </button>
                                                        <div ngbDropdownMenu>
                                                            <a ngbDropdownItem href="javascript:void(0);" 
                                                                *ngIf="filter.isEditMode === false && globalService?.user_settings?.id === filter?.filter?.user_id"
                                                                (click)="onEditFilter(filter)">
                                                                <i data-feather="edit-2" class="me-50"></i><span>{{ t('Edit button text (edit button) - edit') }}</span>
                                                            </a>
    
                                                            <a ngbDropdownItem href="javascript:void(0);" class="ps-1"
                                                                *ngIf="globalService?.user_settings?.id === filter?.filter?.user_id"
                                                                (click)="onDeleteFilter(filter)">
                                                                <i data-feather="trash" class="me-50"></i>
                                                                <span>{{ t('Delete button text (delete button) - delete') }}</span>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                                }
                                            }
                                        </div>
                                    </div>
                                </form>
                            </div>
                        } @empty {
                            <div class="row">
                                <div class="col-12 text-center">
                                    {{t('No filter saved prompt (saved filters modal) - There is no filter saved yet')}}
                                </div>
                            </div>
                        }
                    </div>
                </ng-scrollbar>
            </div>
        </div>
    </div>
</ng-container>
